import { CoKitchenPolygons } from 'models/cokitchen.model';
import { ExternalRiderType } from 'models/external-rider.model';
import moment from 'moment';

type RiderDetailItem = {
  name: string;
  desc?: string;
  type?: string; //could be any of this 2 values 'preview' | 'phone';
  url?: string;
  appropriateVehicle?: string;
};
const vehicleType = {
  bicycle: 'Bicycle',
  motorcycle: 'Motorcycle'
};
export const getRiderDetails = (
  rider: ExternalRiderType & { cokitchenName: string; riderPolygon: CoKitchenPolygons[] }
): RiderDetailItem[] => {
  if (!rider) return [];
  const {
    first_name,
    last_name,
    email_address,
    phone_number,
    national_identity,
    bike_capacity,
    plate_number,
    bike_photo,
    road_worthiness,
    mot,
    lassa,
    mid_year_licence,
    hackney_permit,
    insurance,
    account_name,
    account_number,
    bank_name,
    dob,
    user_gender,
    cokitchenName,
    vehicle_type,
    riderPolygon
  } = rider || {};

  return [
    {
      name: 'Rider name',
      desc: `${first_name || ''} ${last_name || ''}`.trim()
    },
    {
      name: 'Email address',
      desc: email_address ?? ''
    },
    {
      name: 'Mobile no.',
      desc: phone_number ?? ' ',
      type: 'phone'
    },
    {
      name: 'Date of birth',
      desc: moment(new Date(dob)).format('DD MMM, yyyy') ?? 'N/A'
    },
    {
      name: 'Gender',
      desc: user_gender ?? 'N/A'
    },
    {
      name: 'National Identity Number',
      desc: national_identity ?? 'N/A'
    },
    {
      name: 'Bank name',
      desc: bank_name ?? 'N/A'
    },
    {
      name: 'Account Number',
      desc: account_number ?? 'N/A'
    },
    {
      name: 'Account name',
      desc: account_name ?? 'N/A'
    },
    {
      name: 'CoKitchen',
      desc: cokitchenName
    },
    {
      name: 'Polygon',
      desc: riderPolygon.map((pol) => pol.name ?? 'N/A').join(', ') ?? 'N/A'
    },
    {
      name: 'Vehicle type',
      desc: vehicle_type ?? 'N/A'
    },
    {
      name: 'Bike Capacity',
      desc: typeof bike_capacity === 'string' ? bike_capacity : 'N/A',
      appropriateVehicle: vehicleType.motorcycle
    },
    {
      name: 'Bike Plate Number',
      desc: typeof plate_number === 'string' ? plate_number : 'N/A',
      appropriateVehicle: vehicleType.motorcycle
    },
    {
      name: 'Bike Image',
      desc: bike_photo?.name ?? '',
      url: bike_photo?.url ?? '',
      type: 'preview',
      appropriateVehicle: vehicleType.motorcycle
    },
    {
      name: 'Road Worthiness',
      desc: road_worthiness?.name ?? '',
      url: road_worthiness?.url ?? '',
      appropriateVehicle: vehicleType.motorcycle,
      type: 'preview'
    },
    {
      name: 'MOT',
      desc: mot?.name ?? '',
      url: mot?.url ?? '',
      appropriateVehicle: vehicleType.motorcycle,
      type: 'preview'
    },
    {
      name: 'LASSA',
      desc: lassa?.name ?? '',
      url: lassa?.url ?? '',
      appropriateVehicle: vehicleType.motorcycle,
      type: 'preview'
    },
    {
      name: 'Mid-year License',
      desc: mid_year_licence?.name ?? '',
      url: mid_year_licence?.url ?? '',
      appropriateVehicle: vehicleType.motorcycle,
      type: 'preview'
    },
    {
      name: 'Hackney Permit',
      desc: hackney_permit?.name ?? '',
      url: hackney_permit?.url ?? '',
      appropriateVehicle: vehicleType.motorcycle,
      type: 'preview'
    },
    {
      name: 'Insurance',
      desc: insurance?.name ?? '',
      url: insurance?.url ?? '',
      appropriateVehicle: vehicleType.motorcycle,
      type: 'preview'
    }
  ].filter((data) => {
    if (vehicle_type === vehicleType.bicycle) {
      return !data.appropriateVehicle || data.appropriateVehicle !== vehicleType.motorcycle;
    }
    return true;
  });
};
